import { render, staticRenderFns } from "./PayAmount.vue?vue&type=template&id=23151262"
import script from "./PayAmount.vue?vue&type=script&lang=js"
export * from "./PayAmount.vue?vue&type=script&lang=js"
import style0 from "./PayAmount.vue?vue&type=style&index=0&id=23151262&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports